import {
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';
import {
  TABLE_LOAD_DATA,
} from '../actions/types/ListTableActionTypes';
import {
  tableClearData,
  tableLoadDataFailure,
  tableLoadDataSuccess,
} from '../actions/ListTableActions';

function* getTableWorker(action) {
  const {
    tableDefinition,
    tableId,
  } = action.payload;

  try {
    yield put(tableClearData(tableDefinition));
    const result = yield call(tableDefinition.dataProvider, action.payload);
    yield put(tableLoadDataSuccess(tableDefinition, tableId, result.data));
  } catch (error) {
    yield put(tableLoadDataFailure(tableDefinition, tableId, error));
  }
}

function* getTableWatcher() {
  yield takeEvery(TABLE_LOAD_DATA, getTableWorker);
}

export default getTableWatcher;
export { getTableWorker };
